/**
 * SVG `<filter id="puzzle-3d-bevel">` — cardboard cut depth via offset highlights/shadows.
 * Light source ~135° (top-left): highlight shifts up-left, shadow down-right.
 *
 * @param {{ filterId?: string }} props — unique id when multiple overlays on one page
 */
export function Puzzle3DBevelFilter({ filterId = "puzzle-3d-bevel" }) {
    return (
        <filter
            id={filterId}
            x="-10%"
            y="-10%"
            width="120%"
            height="120%"
            colorInterpolationFilters="sRGB"
        >
            {/* Soft alpha matte — bevel blooms without harsh pixel edges */}
            <feGaussianBlur in="SourceAlpha" stdDeviation="0.3" result="blur" />

            {/* Top-left white highlight (135° light) */}
            <feOffset in="blur" dx="-0.45" dy="-0.45" result="highlightOffset" />
            <feFlood floodColor="#ffffff" floodOpacity="0.52" result="highlightColor" />
            <feComposite in="highlightColor" in2="highlightOffset" operator="in" result="highlight" />

            {/* Bottom-right dark shadow (cardboard thickness) */}
            <feOffset in="blur" dx="0.45" dy="0.45" result="shadowOffset" />
            <feFlood floodColor="#1e1e1e" floodOpacity="0.5" result="shadowColor" />
            <feComposite in="shadowColor" in2="shadowOffset" operator="in" result="shadow" />

            {/* Shadow → highlight → core stroke on top */}
            <feMerge>
                <feMergeNode in="shadow" />
                <feMergeNode in="highlight" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>
    );
}

/** Core die stroke — low-opacity dark so lines sit on any photo. */
export const PUZZLE_3D_DIE_STROKE = "rgba(30, 30, 30, 0.45)";

/** Stable filter name for docs / DevTools; suffix with useId() when duplicated on a page. */
export const PUZZLE_3D_BEVEL_FILTER_BASE = "puzzle-3d-bevel";
